/*
 * Copyright 2025 Intuition Robotics ltd
 */
import type { CalendarEvent } from "@app/ir-q-app-common/types/calendar_event";

export enum RSVP {
	PENDING    = "PENDING",
	CONFIRMED  = "CONFIRMED",
	RESCHEDULE = "RESCHEDULE",
	CANCEL     = "CANCEL",
}

export type Appointment = Omit<CalendarEvent, "metadata"> & {
	metadata?: {
		rsvp: RSVP,
		appointmentReminder: boolean;
		medicationReview: boolean;
		videoUploaded: boolean;
	}
}

export type AppointmentConfigFields = keyof Omit<Required<Appointment>["metadata"], "rsvp" | "videoUploaded">;
